/**
 * 通用API响应实体
 * @template T - data字段的数据类型
 */
export class ApiResponse {
  /**
   * @param {Object} options
   * @param {T} options.data - 响应数据
   * @param {string|null} options.errmsg - 错误消息
   * @param {number} options.errno - 错误号
   * @param {string} options.status - 状态（"True" 或 "False"）
   */
  constructor({ data, errmsg = null, errno = 0, status = 'True' }) {
    this.data = data
    this.errmsg = errmsg
    this.errno = errno
    this.status = status
  }

  /**
   * 判断响应是否成功（仅根据errno判断，errno为0表示成功）
   * @returns {boolean}
   */
  isSuccess() {
    return this.errno === 0
  }

  /**
   * 判断响应是否失败（errno不为0表示失败）
   * @returns {boolean}
   */
  isError() {
    return this.errno !== 0
  }
}

/**
 * 创建成功响应
 * @template T
 * @param {T} data - 响应数据
 * @param {string|null} errmsg - 错误消息（可选）
 * @returns {ApiResponse<T>}
 */
export function createSuccessResponse(data, errmsg = null) {
  return new ApiResponse({
    data,
    errmsg,
    errno: 0,
    status: 'True'
  })
}

/**
 * 创建失败响应
 * @param {string} errmsg - 错误消息
 * @param {number} errno - 错误号
 * @returns {ApiResponse<null>}
 */
export function createErrorResponse(errmsg, errno = -1) {
  return new ApiResponse({
    data: null,
    errmsg,
    errno,
    status: 'False'
  })
}

/**
 * 通用API响应类型定义（用于TypeScript或JSDoc）
 * @typedef {Object} ApiResponseType
 * @template T
 * @property {T} data - 响应数据
 * @property {string|null} errmsg - 错误消息
 * @property {number} errno - 错误号
 * @property {string} status - 状态（"True" 或 "False"）
 */

